<template>
	<div class="column">
		<div class="col">
			<span class="text-overline">{{ $t('searchType') }}</span>
		</div>
		<div class="col">
			<q-btn-group>
				<q-btn @click="$emit('updatedSearchType', blockSearch)" icon="img:\typo3conf\ext\ig_warehouse\Resources\Public\Icons\logs-24.svg" :class="viewButtonClass(blockSearch)">
					<q-tooltip>{{ $t('searchTypes.blockSearch') }}</q-tooltip>
				</q-btn>
				<q-btn @click="$emit('updatedSearchType', palletSearch)" icon="img:\typo3conf\ext\ig_warehouse\Resources\Public\Icons\pallets-24.svg" :class="viewButtonClass(palletSearch)">
					<q-tooltip>{{ $t('searchTypes.palletSearch') }}</q-tooltip>
				</q-btn>
			</q-btn-group>
		</div>
	</div>
</template>

<script>
	import {SEARCH_TYPE} from "@/common/constants";
	import {mapGetters} from "vuex";

	export default {
		name: "SearchTypeSelect",
		computed: {
			...mapGetters(['searchType']),
			blockSearch() {
				return SEARCH_TYPE.BLOCK;
			},
			palletSearch() {
				return SEARCH_TYPE.PALLET;
			}
		},
		methods: {
			viewButtonClass(value) {
				return value === this.searchType ? 'bg-primary' : '';
			}
		}
	}
</script>

<style scoped>

</style>